import { useSelector } from "react-redux";
// import { login, logout } from "store/

function useThemeSettings() {
  const primary = useSelector((state) => state.color.color);

  return {
    primary,
  };
}

export default useThemeSettings;
